export default __webpack_public_path__ + "static/media/mutation-phone3.75014199.png";